<template>
    <div class="device-type-manange relative">

        <div class="buttons"  :style="{position: button_position}">

        </div>

        <!-- 表单开始 -->
        <el-row class="inputs mg-20 search" :gutter="20">
            <el-col :md="5" :lg="4" :xl="4" :sm="6" :xs="12">
                <span class="fs-14 pd-r-10">姓名：</span>
                <el-input v-model="user_name" placeholder="姓名模糊搜索"/>
            </el-col>
            <el-col :md="5" :lg="4" :xl="4" :sm="6" :xs="12">
                <span class="fs-14 pd-r-10">用户类型：</span>
                <el-select
                    clearable
                    class="status" v-model="role_type" placeholder="请选择用户类型" style="width: 100%;max-width: none !important;">
                    <el-option
                        v-for="item in allRole"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                    ></el-option>
                </el-select>
            </el-col>
        </el-row>
        <el-row class="inputs mg-20 search" :gutter="20">
            <el-col :md="5" :lg="4" :xl="4" :sm="6" :xs="12">
                <span class="fs-14 pd-r-10">手机：</span>
                <el-input v-model="mobile" placeholder="手机模糊搜索"/>
            </el-col>

            <el-col :md="5" :lg="4" :xl="4" :sm="6" :xs="12">
                <el-button @click="resetForm">重置</el-button>
                <el-button @click="search">筛选</el-button>
            </el-col>
        </el-row>
        <!-- 表单结束 -->
        <div class="docker_buttons sms_buttons">
            <el-button type="primary" @click="goInterval">定时任务列表</el-button>
            <el-button type="primary" @click="sendSms('interval_multi')">定时批量发送</el-button>
            <el-button type="primary" @click="sendSms('interval_all')">定时群发</el-button>
            <el-button type="primary" @click="sendSms('multi')">批量发送</el-button>
            <el-button type="primary" @click="sendSms('all')">群发</el-button>
        </div>

        <el-table ref="multipleTable"
                  :data="tableData"
                  border
                  @selection-change="selectUsers"
                  style="width: 100%">
            <el-table-column type="selection" width="40">
            </el-table-column>
            <el-table-column width="50" prop="no" label="序号" align="center" label-class-name="label"></el-table-column>
            <el-table-column prop="user_name" label="姓名" align="center" label-class-name="label"></el-table-column>
            <el-table-column prop="mobile" label="手机号" align="center" label-class-name="label"></el-table-column>
            <el-table-column prop="role_type" label="用户类型" align="center" label-class-name="label"></el-table-column>
            <el-table-column prop="message_count" label="问候短信数" align="center" label-class-name="label"></el-table-column>
            <el-table-column prop="message_date" label="最新短信发送时间" align="center"
                             label-class-name="label"></el-table-column>
            <el-table-column
                    prop="address"
                    label="操作"
                    align="center"
                    label-class-name="label"
                    v-slot="scope"
            >
                <el-button @click="goUserList(scope.row)"
                           type="text" size="mini">查看问候短信
                </el-button>
            </el-table-column>
        </el-table>
        <el-pagination
                class="mg-20 ta-r"
                background
                layout="total, sizes, prev, pager, next, jumper"
                :page-sizes="[10, 25, 50, 100]"
                :total="total"
                :page-size="perpage"
                :current-page="page"
                @current-change="changePage"
                @size-change="changeSite"
        ></el-pagination>
        <el-dialog
            :title="dialog_title"
            :visible.sync="dialogVisible"
            width="30%"
            id="sms_dialog"
            center>
            <el-form label-position="right" :model="smsForm" :rules="smsRules" ref="smsForm"
                     label-width="100px"
                     class="form" style="width: 90%;margin: 20px auto 0 auto;" autocomplete="off">
                <el-form-item label="发送时间" prop="send_time" v-if="is_interval">
                    <el-date-picker
                        v-model="smsForm.send_time"
                        type="datetime"
                        default-time="8:00:00"
                        placeholder="选择发送时间">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="问候用户" prop="user_ids" v-if="!is_sms_send_all">
                    <el-select v-model="smsForm.user_ids"
                               multiple
                               placeholder="请选择问候用户"
                               style="width: 100%;">
                        <el-option
                            v-for="item in tableData"
                            :key="item.user_id"
                            :label="item.user_name"
                            :value="item.user_id"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="问候用户" prop="sms_type" v-if="is_sms_send_all">
                    <el-select v-model="smsForm.sms_type" placeholder="请选择发送短信"
                               style="width: 100%;">
                        <el-option
                            v-for="item in allSmsRole"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="问候短信" prop="template_id" class="sms_template" style="margin-bottom: 0;">
                    <el-select v-model="smsForm.template_id" placeholder="请选择发送短信"
                               style="width: 100%;" @change="selectSms">
                        <el-option
                            v-for="item in allSmsTmpl"
                            :key="item.template_id"
                            :label="item.name"
                            :value="item.template_id"
                        ></el-option>
                    </el-select>
                    <div class="el-form-item__error">短信条数：{{sms_num}}</div>
                    <span style="margin-left: 5px;text-decoration: underline;
                    color: #4E6EF2;
                    display: inline-block;
                    transform: translateY(-10px);
                    text-decoration-color: #4E6EF2;cursor: pointer;"
                    @click="addTmpl"
                    >
                        添加短信模板</span>
                </el-form-item>
                <el-form-item label="任务描述">
                    <el-input type="text" v-model="smsForm.title"  autocomplete="off"
                              style="width: calc(100% - 10px);"></el-input>
                </el-form-item>
                <el-form-item label="短信内容">
                    <el-input class="sms_textarea" type="textarea" :autosize="true" v-model="smsForm.sms_content" :disabled="true" autocomplete="off"
                              style="width: calc(100% - 10px);"></el-input>
                </el-form-item>
                <el-form-item label="系统消息推送" prop="status">
                    <el-radio-group v-model="smsForm.is_push">
                        <el-radio :label="1">推送</el-radio>
                        <el-radio :label="2">不推送</el-radio>
                    </el-radio-group>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="success" @click="sendPromotionSms('smsForm')">{{ submit_txt }}</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
    import {export2Excel} from "@/utils/excel";
    import env from "@/api/env";
    import {check} from "@/utils/checkData";
    import {authUrlCheck, isMobile} from "@/api/order";
    import {getUserInfos} from "@/utils/userInfos";

    export default {
        data() {
            return {
                page: 1,
                perpage: 10,
                total: 0,
                tableData: [],
                allSmsTmpl: [],
                allRole: [
                    {
                        id: '1',
                        name: '特属服务对象'
                    },
                    {
                        id: '3',
                        name: '特属专家'
                    },
                ],
                allSmsRole: [
                    {
                        id: '6',
                        name: '所有用户'
                    },
                    {
                        id: '1',
                        name: '特属服务对象'
                    },
                    {
                        id: '3',
                        name: '特属专家'
                    },
                ],
                smsForm: {
                    user_ids: [],
                    template_id: '',
                    title: '',
                    sms_type: '6',
                    sms_content: '',
                    send_time: '',
                    is_push: 2,
                },
                smsRules: {
                    user_ids: [
                        {required: true, message: "请选择问候用户", trigger: "blur"},
                    ],
                    sms_type: [
                        {required: true, message: "请选择问候用户", trigger: "blur"},
                    ],
                    template_id: [
                        {required: true, message: "请选择需要发送的短信", trigger: "blur"},
                    ],
                    send_time: [
                        {required: true, message: "请选择发送时间", trigger: "blur"},
                    ],
                },
                user_name: '',
                mobile: '',
                role_type: '',
                button_position: 'absolute',
                is_mobile: false,
                is_submit: false,
                dialog_title: '批量发送问候短信',
                dialogVisible: false,
                is_sms_send_all: true,
                is_interval: false,
                role_id: 0,
                submit_txt:'发送',
                sms_num: 0,
            };
        },
        created() {
            if (isMobile()) {
                this.button_position = 'static'
                this.is_mobile = true
            }
            let userInfo = getUserInfos()
            if (userInfo) {
                this.role_id = parseInt(userInfo.role_id)
                this.child_role_id = parseInt(userInfo.child_role_id)
            }
        },
        mounted() {
            // 获取列表
            let prev_page = localStorage.getItem('prev_page');
            if (prev_page == 'system_message_add' || prev_page == 'sms_list') {
                this.user_name = localStorage.getItem('sms_user_name')
                this.mobile = localStorage.getItem('sms_mobile')
                this.role_type = localStorage.getItem('sms_type')
                if (this.mobile == 'undefined' || this.mobile == 'null') {
                    this.mobile = ''
                }
                if (this.user_name == 'undefined' || this.user_name == 'null') {
                    this.user_name = ''
                }
                if (this.role_type == 'undefined' || this.role_type == 'null') {
                    this.role_type = ''
                }
                if (this.role_type) {
                    this.role_type = parseInt(this.role_type)
                }
            }
            this.getList();
            this.smsTmpl();
        },
        methods: {
            dialogRest() {
                this.smsForm.user_ids = []
                this.smsForm.template_id = ''
                this.smsForm.sms_type = '6'
                this.smsForm.sms_content = ''
                this.smsForm.send_time = ''
                this.smsForm.is_push = 2
            },
            // 定时任务列表
            goInterval(){
                console.log(this.role_id, this.role_id > 1)
                if (this.role_id > 1) {
                    if (!authUrlCheck('/admin/operate/SmsIntervalList', this.$store.getters.authUrl)) {
                        return;
                    }
                }
                this.$router.push({name: "smsIntervalList", params: {}});
                return;
            },
            addTmpl() {
                if (this.role_id > 1) {
                    if (!authUrlCheck('/admin/operate/SmsTmplList', this.$store.getters.authUrl)) {
                        return;
                    }
                }
                this.$router.push({name: "smsTmplList", params: {}});
                return;
            },
            smsTmpl() {
                let params = {
                    servername: 'Ruyi_AdminNewOperateServices',
                    method: 'smsTmplList',
                    params: {
                        type: "send_promotion_sms"
                    }
                };
                this.$api.service(params).then(res => {
                    if (!check(res)) {
                        return;
                    }
                    this.allSmsTmpl = res.data.data.list;
                });
            },
            // 获取所有医生
            getList() {
                let params = {
                    servername: 'Ruyi_ContentServices',
                    method: 'getSmsUser',
                    pageinfo: {
                        page: this.page,
                        perpage: this.perpage,
                    },
                    params: {
                        user_name: this.user_name,
                        mobile: this.mobile,
                        role_type: this.role_type,
                    }
                };
                this.$api.service(params).then(res => {
                    if (!check(res)) {
                        return;
                    }
                    for (var i = 0; i < res.data.data.list.length; i++) {
                        res.data.data.list[i].no = (this.page - 1) * this.perpage + i + 1
                        switch (res.data.data.list[i].role_type) {
                            case '1':
                                res.data.data.list[i].role_type = '特属服务对象';
                                res.data.data.list[i].role_type_number = 1;
                                break;
                            case '3':
                                res.data.data.list[i].role_type = '特属专家';
                                res.data.data.list[i].role_type_number = 3;
                                break;
                        }
                    }
                    localStorage.setItem('system_message_user_name', this.user_name)
                    localStorage.setItem('system_message_mobile', this.mobile)
                    localStorage.setItem('system_message_role_type', this.role_type)
                    localStorage.setItem('page', this.page)
                    localStorage.setItem('perpage', this.perpage)
                    localStorage.setItem('prev_page', 'system_message_list')
                    this.tableData = res.data.data.list;
                    this.total = res.data.data.page.count;
                    this.smsForm.user_ids = []
                });
            },

            // 改变每页条数
            changeSite(index) {
                this.perpage = index;
                this.getList();
            },

            //更换页码
            changePage(index) {
                this.page = index;
                this.getList();
            },

            // 重置按钮
            resetForm() {
                this.user_name = "";
                this.mobile = "";
                this.role_type = "";
                this.page = 1;
                this.getList();
            },

            // 搜索
            search() {
                this.page = 1;
                this.getList();
            },


            goUserList(data) {
                this.$router.push({
                    name: "userSmsList", params: {
                        user_id: data.user_id,
                        user_name: data.user_name,
                        mobile: data.mobile,
                        user_role: data.role_type,
                    }
                });
            },
            selectUsers(data) {
                let len = data.length
                this.smsForm.user_ids = [];
                this.smsForm.sms_type = 9
                for (let i = 0; i < len; i++) {
                    this.smsForm.user_ids.push(data[i].user_id)
                }
            },
            selectSms(){
                let len = this.allSmsTmpl.length
                console.log(this.smsForm.template_id, len)
                for (let i = 0; i < len; i++) {
                    if (this.allSmsTmpl[i].template_id == this.smsForm.template_id) {
                        this.smsForm.sms_content = this.allSmsTmpl[i].content
                        this.smsForm.title = this.allSmsTmpl[i].name
                    }
                }
                let content_len = this.smsForm.sms_content.length + 5
                if (content_len <= 70) {
                    this.sms_num = 1;
                } else {
                    this.sms_num = Math.ceil(content_len / 67)
                }
            },
            // 发送短信
            sendSms(type) {
                if (type !== 'all' && type !== 'interval_all' && this.smsForm.user_ids.length < 1) {
                    this.$message({
                        type: "warning",
                        message: '请选择需要发送问候短信的用户',
                        duration: 1500,
                    });
                    return;
                }
                this.smsForm.template_id = ''
                this.smsForm.sms_content = ''
                switch (type) {
                    case 'interval_all':
                        this.is_interval = true;
                        this.is_sms_send_all = true
                        this.dialog_title = '定时群发问候短信'
                        this.smsRules.sms_type = ''
                        this.submit_txt = '添加'
                        break;
                    case 'interval_multi':
                        this.is_interval = true;
                        this.is_sms_send_all = false
                        this.dialog_title = '定时批量发送问候短信'
                        this.smsForm.sms_type = 9
                        this.submit_txt = '添加'
                        break;
                    case 'all':
                        this.is_sms_send_all = true
                        this.dialog_title = '群发问候短信'
                        this.smsForm.sms_type = ''
                        this.submit_txt = '发送'
                        break
                    case 'multi':
                        this.is_sms_send_all = false
                        this.dialog_title = '批量发送问候短信'
                        this.smsRules.sms_type = 9
                        this.submit_txt = '发送'
                        break
                }

                this.dialogVisible = true
            },
            sendPromotionSms(formName) {
                if (this.is_submit) {
                    // 重复提交提醒
                    this.$message({
                        type: "warning",
                        message: '正在处理请求，请不要重复提交',
                        duration: 1500,
                    });
                    return;
                }

                this.is_submit = true;
                let _that = this
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        let params = {
                            'servername': 'Ruyi_ContentServices',
                            'method': 'sendPromotionSms',
                            'params': {
                                user_ids: this.smsForm.user_ids,
                                sms_type: this.smsForm.sms_type,
                                template_id: this.smsForm.template_id,
                                send_time: this.smsForm.send_time,
                                title: this.smsForm.title,
                                is_push: this.smsForm.is_push,
                            }
                        };
                        this.$api.service(params).then(res => {
                            if (!check(res)) {
                                this.is_submit = false;
                                return;
                            }
                            let message = '发送成功';
                            if (this.is_interval) {
                                message = '定时任务添加成功'
                            }
                            this.$message({
                                type: "success",
                                message: message,
                                duration: 1500,
                                onClose: function () {
                                    _that.is_submit = false;
                                    _that.dialogVisible = false;
                                    _that.dialogRest()
                                    _that.getList()
                                    return;
                                }
                            });
                        }).finally(() => {
                            this.is_submit = false;
                        });
                    } else {
                        console.log(valid)
                        this.$message({
                            type: "error",
                            message: '请输入必填项'
                        });
                        this.is_submit = false;
                        return false;
                    }
                })
            },
        }
    };
</script>
<style lang="scss">
    @import "@/styles/common.scss";

    .docker_buttons {
        float: right;
        margin: 30px 0px 8px 0px;
    }
    .el-col{
        margin-bottom: 10px;
        input{
            width: 100%;
        }
    }
    .inputs .el-select.status .el-input {
        width: 100%;
    }
    .search .el-input {
        width: 100% !important;
    }
    .sms_textarea{
        textarea.el-textarea__inner {
            background-color: #FFFFFF !important;
            color: #000000 !important;
        }
    }
    #sms_dialog{
        .el-dialog{
            min-width: 560px;
        }
    }
    .sms_template {
        .el-form-item__error{
            transform: translate(100px,-40px);
        }
    }
    .sms_buttons{
        .el-button {
            width: auto;
            height: 32px;
            line-height: 7px;
            margin-left: 5px;
        }
    }
</style>
